import request from '@/utils/request'

export function getActivtyTypesList() {
  return request({
    url: 'api/v1/activity/getTypes',
    method: 'get'
  })
}

export function copyActivtyData(data) {
  return request({
    url: 'api/v1/activity/copyData',
    method: 'post',
    data: data
  })
}

export function getActivityTypeToMap(data) {
  return request({
    url: 'api/v1/activity/getActTypeToMap',
    method: 'post',
    data: data
  })
}

export function getConditionTypesList() {
  return request({
    url: 'api/v1/activity/getConditionTypes',
    method: 'get'
  })
}

export function getCollectTypesList() {
  return request({
    url: 'api/v1/activity/getCollectTypes',
    method: 'get'
  })
}

export function getStealAttackTYpesList() {
  return request({
    url: 'api/v1/activity/getStealAttackTypes',
    method: 'get'
  })
}

export function getTaskTypesList() {
  return request({
    url: 'api/v1/activity/getTaskTypes',
    method: 'get'
  })
}

export function updateActivtyCfg(data) {
  return request({
    url: 'api/v1/activity/update',
    method: 'post',
    data: data
  })
}

export function updateActivtySkinCfg(data) {
  return request({
    url: 'api/v1/activity/updateSkin',
    method: 'post',
    data: data
  })
}

export function getActivtyRuleCondCfg(data) {
  return request({
    url: 'api/v1/activity/getActRuleCondList',
    method: 'post',
    data: data
  })
}
export function updateActivtyRuleCondCfg(data) {
  return request({
    url: 'api/v1/activity/updateActRuleCondList',
    method: 'post',
    data: data
  })
}
export function delActivtyRuleCondCfg(data) {
  return request({
    url: 'api/v1/activity/delActRuleCondList',
    method: 'delete',
    data: data
  })
}
export function updateActivtyRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/update',
    method: 'post',
    data: data
  })
}

export function updateActivtyStageRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/updateActivityStageReward',
    method: 'post',
    data: data
  })
}

export function updateTrafficPermitCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/updateTrafficPermitCfg',
    method: 'post',
    data: data
  })
}

export function exportActivtyRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/export',
    method: 'post',
    data: data
  })
}

export function exportStageCoefficientCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/exportStageCoefficient',
    method: 'post',
    data: data
  })
}

export function getStageCoefficientList(data) {
  return request({
    url: 'api/v1/act-stage-reward/getStageCoefficient',
    method: 'post',
    data: data
  })
}

export function importActivtyRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/import',
    method: 'post',
    data: data
  })
}

export function importActivtyStageCoefficientCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/importStageCoefficient',
    method: 'post',
    data: data
  })
}

export function updateActivtyExtraData(data) {
  return request({
    url: 'api/v1/activity/updateExtraData',
    method: 'post',
    data: data
  })
}
export function updateActivtyProData(data) {
  return request({
    url: 'api/v1/activity/updateRewardPro',
    method: 'post',
    data: data
  })
}
export function updateActivtyRewardConfData(data) {
  return request({
    url: 'api/v1/activity/updateRewardConf',
    method: 'post',
    data: data
  })
}
export function getActivtyRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/getList',
    method: 'post',
    data: data
  })
}

export function getActivtyStageRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/getActivityRewardList',
    method: 'post',
    data: data
  })
}

export function getActivtyList(data) {
  return request({
    url: 'api/v1/activity/getList',
    method: 'post',
    data: data
  })
}
export function getActivtyAllList(data) {
  return request({
    url: 'api/v1/activity/getListAll',
    method: 'post',
    data: data
  })
}
export function getActivtyImgList(data) {
  return request({
    url: 'api/v1/activity/getActImg',
    method: 'post',
    data: data
  })
}

export function delActivtyCfg(data) {
  return request({
    url: 'api/v1/activity/delete',
    method: 'delete',
    data: data
  })
}
export function changeActivtyOnline(data) {
  return request({
    url: 'api/v1/activity/changeOnline',
    method: 'post',
    data: data
  })
}

export function exportAct(data) {
  return request({
    url: 'api/v1/activity/export',
    method: 'post',
    data: data
  })
}
export function delActivtyRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/delFirst',
    method: 'delete',
    data: data
  })
}

export function actRuleCondSyncOss(data) {
  return request({
    url: 'api/v1/activity/actRuleSyncOss',
    method: 'post',
    data: data
  })
}

export function delActivtyFirstRewardCfg(data) {
  return request({
    url: 'api/v1/act-stage-reward/delRewardFirst',
    method: 'delete',
    data: data
  })
}

export function getPropsActList(data) {
  return request({
    url: 'api/v1/activity/getPropsActList',
    method: 'post',
    data: data
  })
}
